import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationService } from '../../providers/navigation.service';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../providers/api.service';
import { Subscription } from 'rxjs';
import { SM_CONSTANTS } from '../../shared/constants/sm-constants';
import { ITableColumnHeader } from '../../models/table-column-header';
import { AddServiceComponent } from 'src/app/shared/components/add-service/add-service.component';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from '../../providers/shared.service';
import { FormControl } from '@angular/forms';
import { AddServiceTemplateItemComponent } from 'src/app/shared/components/add-service-template-item/add-service-template-item.component';
import { AddServiceTimingsComponent } from 'src/app/shared/components/add-service-timings/add-service-timings.component';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { MessagingService } from 'src/app/providers/messaging.service';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { RenewBusinessComponent } from 'src/app/shared/components/renew-business/renew-business.component';
import { AddEmployeeSalaryComponent } from 'src/app/shared/components/add-employee-salary/add-employee-salary.component';
import { CustomConfirmDialogComponent } from 'src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { SalaryDetailsComponent } from '../new-v2-pages/new-v2-component/salary-details/salary-details.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'sm-employee-salary',
  templateUrl: './employee-salary.component.html',
  styleUrls: ['./employee-salary.component.scss']
})
export class EmployeeSalaryComponent implements OnInit, OnDestroy {
  entityHashId: string = '';
  employeeHash: string = '';
  serviceType: string = '';
  public loader: boolean = false;
  serviceTimings: any = []
  finalServiceTimings: any = [{
    dayName: "Entity Monthly Plan",
    openTime: "28 Nov, 2023",
    closeTime: "27 Dec, 2023",
    status: "Active"
  }]
  salaryData: any[] = [];
  private _apiSubscription: Subscription;
  datalength!: number
  public page: number = 1;
  searchString: FormControl = new FormControl('');

  daysOfWeek = [
    { day: 1, name: 'Sunday' },
    { day: 2, name: 'Monday' },
    { day: 3, name: 'Tuesday' },
    { day: 4, name: 'Wednesday' },
    { day: 5, name: 'Thursday' },
    { day: 6, name: 'Friday' },
    { day: 7, name: 'Saturday' }
  ];

  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: this.translateService.instant('employee_salary.column_headers.pay_type'),
      columnProperty: "payType1"
    },
    {
      columnName: this.translateService.instant('employee_salary.column_headers.paid_on'),
      columnProperty: "paidOn1"
    },
    // {
    //   columnName: 'Pay rate',
    //   columnProperty: "e_amount"
    // },
    {
      columnName: this.translateService.instant('employee_salary.column_headers.working_days'),
      columnProperty: "workingDays"
    },
    {
      columnName: this.translateService.instant('employee_salary.column_headers.paid_leave'),
      columnProperty: "paidLeave"
    },
    {
      columnName: this.translateService.instant('employee_salary.column_headers.unpaid_leave'),
      columnProperty: "unPaidLeave"
    },
    {
      columnName: this.translateService.instant('employee_salary.column_headers.gross_payment'),
      columnProperty: "e_netPayment"
    },
    {
      columnName: this.translateService.instant('employee_salary.column_headers.other_perks'),
      columnProperty: "e_otherPerks"
    },
    {
      columnName: this.translateService.instant('employee_salary.column_headers.deduction'),
      columnProperty: "e_deduction"
    },
    {
      columnName: 'Net pay',
      columnProperty: "np"
    },
    {
      columnName: this.translateService.instant('employee_salary.column_headers.salary_type'),
      columnProperty: "salaryType1"
    },
    {
      columnName: this.translateService.instant('employee_salary.column_headers.salary_for'),
      columnProperty: "paid_for"
    },
    {
      columnName: this.translateService.instant('employee_salary.column_headers.salary_dispense_date'),
      columnProperty: "salaryCreditDate"
    },
    {
      columnName: this.translateService.instant('employee_salary.column_headers.notes'),
      columnProperty: "notes"
    },
    
  ];
  
  constructor(private datePipe: DatePipe,private _navService: NavigationService, private route: ActivatedRoute, private _apiService: ApiService, private _modelRef: MatDialog, private sharedService: SharedService, private loaderservice: LoaderServiceService,private messagingService: MessagingService, 
    private angularFireMessaging: AngularFireMessaging,private translateService: TranslateService) { 
    this._navService.hideSidebarAndNav = false;
    // this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
    //   this.ngOnInit();
    // })
    
    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_SALARY_INFO){
        this.salaryData = []
        if(resData.result){
          resData.result.forEach((element:any) => {
            if(element.payType == 1){
              element.payType1 = 'hourly'
            }
            else if(element.payType == 2){
              element.payType1 = 'daily'
            }
            else if(element.payType == 3){
              element.payType1 = 'weekly'
            }
            else if(element.payType == 4){
              element.payType1 = 'monthly'
            }

            if(element.salaryType == 1){
              element.salaryType1 = 'normal salary'
            }
            else if(element.salaryType == 2){
              element.salaryType1 = 'advance salary'
            }

            if(element.paidOn == 1){
              element.paidOn1 = 'Daily'

              element.paid_for = this.datePipe.transform(element.salaryFromDate, 'MMMM d, y');
            }
            if(element.paidOn == 2){
              element.paidOn1 = 'weekly'
              element.paid_for = this.datePipe.transform(element.salaryFromDate, 'MMMM d, y') + ' - ' + this.datePipe.transform(element.salaryToDate, 'MMMM d, y');

            }
            if(element.paidOn == 3){
              element.paidOn1 = 'monthly'
              element.paid_for = this.datePipe.transform(element.salaryFromDate, 'MMMM y');

            }

            
            element.np = +element.netPayment + +element.otherPerks - +element.deduction
            element.e_amount = element.currency_symbol + element.amount
            element.e_deduction = element.currency_symbol + element.deduction
            element.e_otherPerks = element.currency_symbol + element.otherPerks 
            element.e_netPayment = element.currency_symbol +  element.netPayment 
            this.salaryData.push(element)  
          });
          
        }
        this.loader = false;
      this.loaderservice.showLoader = false
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_SALARY_INFO){ 
        // alert("calling from plan and renew")
        
        if(resData.result){
          
          this.loaderservice.showLoader = false
          this.ngOnInit()
        }
       }

      
      
    });
    if(!localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == 'null'){
      this.messagingService.requestPermission();
    }
    // this.translateService.onLangChange.subscribe(() => {
    //   // Update your column headers when the language changes
    //   this.updateColumnHeaders();
    // });
  }
  private updateColumnHeaders() {
    this.tableDisplayColumns.forEach((column,index) => {
      let data = [
        "pay_type",
        "paid_on",
        "credit_amount",
        "working_days",
        "paid_leave",
        "unpaid_leave",
        "deduction",
        "salary_type",
        "other_perks",
        "notes",
        "gross_payment",
        "salary_dispense_date",
        "salary_for"
      ]
      
      // Update each column header with the translated value
      column.columnName = this.translateService.instant(`employee_salary.column_headers.${data[index]}`);
    });
  }
  // private modelSubscription: Subscription = new Subscription();
  ngOnInit(): void {
  
   
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash
      this.employeeHash = data.employeeHash
      
    })
    this.loader = true;
    this.loaderservice.showLoader = true
    this._apiService.getSalaryInfo(this.employeeHash, '0')

    // if(this.serviceType == '0'){
    //   this.loaderservice.showLoader = true
    //   this._apiService.getHomeServiceTimeDetails(this.entityHashId)
    // }
    // else if(this.serviceType == '1'){
    //   this.loaderservice.showLoader = true
    //   this._apiService.getShopEntityTimeDetails(this.entityHashId)
    // }


    // this.modelSubscription = this._modelRef.afterAllClosed.subscribe((data) => {
    //   this.loader = true;
    //   this._apiService.getServices(this.entityHashId)
    // });

  }

  createNotification(title:any, text:any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

  onCreateNewService(){
this._modelRef.open(AddServiceComponent, {
      width: '700px',
      data: {
        title: 'Add service',
        type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
        ref: this._modelRef,
      },
    });
  }
  onCreateNewServiceFromTemplate(){
this._modelRef.open(AddServiceTemplateItemComponent, {
      width: '500px',
      data: {
        title: 'Add Salary',
        ref: this._modelRef,
      },
    });
  }

  viewdetails(item:any){
    this._modelRef.open(SalaryDetailsComponent, {
      width: '500px',
      data: {
        title: 'Salary details',
        ref: this._modelRef,
        data: item,
        isOwner: 1
      },
    });
  }

  addSalary(){
    let data = {
      editMode: false,
      employeeHash: this.employeeHash
    }
    this._modelRef.open(AddEmployeeSalaryComponent, {
      width: '500px',
      data: {
        title: 'Add Salary',
        ref: this._modelRef,
        data: data
      },
    });
  }

  editSalary(item:any){
    let data = {
      editMode: true,
      employeeHash: this.employeeHash,
      salaryData: item
    }
    this._modelRef.open(AddEmployeeSalaryComponent, {
      width: '500px',
      data: {
        title: 'Edit Salary',
        ref: this._modelRef,
        data: data
      },
    });
  }
  deleteSalary(item:any){
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
      data : {
        title : 'Alert',
        message : 'Are you sure you want to delete this salary?',
        okbtn : 'Confirm',
        cancelbtn : 'Cancel',
        type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
      },
      disableClose : true
    });
    dialogRef.afterClosed().subscribe(result=>{
      console.log(result);
      if(result){ 
        let data = {
          salaryInfo : {
            hash_id: item.hash_id,
            isDelete: 1
          }
        }
    
        this.loaderservice.showLoader = true
        this._apiService.updateSalaryInfo(this.employeeHash,data,'0')
      }
    })
   
  }
  openAddTime(rowvalue:any){
    rowvalue.serviceType = this.serviceType
    rowvalue.entityHash = this.entityHashId
    this._modelRef.open(AddServiceTimingsComponent, {
      width: '500px',
      data: {
        title: 'Add service timing',
        ref: this._modelRef,
        data: rowvalue
      },
    });
  }

  removeTime(rowvalue:any){
    if(this.serviceType == '0'){
      let data = {
        homeServiceTimeInfo : {
          timeList : [
            {
              hashId: rowvalue.hashId,
              status: 2
            }
          ]
        }
      }
      this._apiService.updateHomeServiceTimeInfo(
        this.entityHashId,
        data
      );
    }
    else if(this.serviceType == '1'){
      let data = {
        entityTimeInfo : {
          timeList : [
            {
              hashId: rowvalue.hashId,
              status: 2
            }
          ]
        }
      }
      this._apiService.updateEntityShopTimeInfo(
        this.entityHashId,
        data
      );
    }
  }

  deactivateService(rowvalue: any){
console.log(rowvalue);
let metadata = {
  serviceTypeInfo: {
    hash_id: rowvalue.hash_id,
    status: 7
  }
}

this._apiService.addUpdateServiceType(metadata, this.entityHashId)

// setTimeout(() => {
//   this.ngOnInit();
// }, 1500);

  }

  activateService(rowvalue:any){
    console.log(rowvalue);
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        status: 1
      }
    }
    
    this._apiService.addUpdateServiceType(metadata, this.entityHashId)
    
    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  deleteService(rowvalue:any){
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        isDelete: 1
      }
    }

    this._apiService.addUpdateServiceType(metadata, this.entityHashId)
    
    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  onEdit(rowvalue:any){
    this._modelRef.open(AddServiceComponent, {
      width: '700px',
      data: {
        title: 'Add service',
        type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
        ref: this._modelRef,
        data: rowvalue,
      },
    });
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    // this.clickEventSubscription.unsubscribe();
    // this.modelSubscription.unsubscribe();
  }

  
  onPageChange(ev: any) {
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;
    
    // //this._apiService.getServices(this.entityHashId, this.page.toString())
  }

  firstTimeBelow3:boolean = false;

  searchServiceData(){
    if(this.searchString.value.length >= 3){
      this.firstTimeBelow3 = true
      this.page = 1
      this._apiService.getServiceDataByKeyword(this.entityHashId,this.page, this.searchString.value)
    }
    else{
      if (this.firstTimeBelow3) {
      this.firstTimeBelow3 = false
      this.page = 1
      // //this._apiService.getServices(this.entityHashId, this.page.toString())
      }
    }
  }

  reset(){
    this.searchString.reset()
    this.page = 1
    //this._apiService.getServices(this.entityHashId, this.page.toString())
  }

  renewBusiness(){
    this._modelRef.open(RenewBusinessComponent, {
      width: '500px',
      data: {
        title: 'Recharge Business',
        ref: this._modelRef,
        data: this.entityHashId
      },
    });
}

  convertTo12HourFormat(timeString:any) {
    
    const [hours, minutes] = timeString.split(':');
    let period = 'AM';
    let hour = parseInt(hours, 10);
  
    if (hour >= 12) {
      period = 'PM';
      if (hour > 12) {
        hour -= 12;
      }
    }
  
    return `${hour.toString().padStart(2, '0')}:${minutes} ${period}`;
  }


}

